import {API_URL} from "../../components/config/BaseUrl";

export const USER_ALLOCATED_NUMBERS_URL = `${API_URL}/numbers/assign`;
export const GET_AVAILABLE_NUMBERS_URL = `${API_URL}/numbers/availablenumbers`;
export const ASSIGN_NUMBER_URL = `${API_URL}/numbers`;